import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';
import { MspInProductTrialsStartTrialPopUpWebController } from '../controller/MspInProductTrialsStartTrialPopUpWebController';
import { FormGroup } from '../../../../ui/gzForm/formGroup/form-group';
import { MspInProductTrialId } from '../../../../company/common/mspInProductTrialsTab/types/msp-in-product-trials-types';

export class MspInProductTrialsStartTrialPopUpWebComponent extends BaseWebComponentElement {
  public controller!: MspInProductTrialsStartTrialPopUpWebController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: MspInProductTrialsStartTrialPopUpWebController,
    });
  }

  public getFormGroup(): FormGroup {
    return this.controller.getFormGroup();
  }

  public setFormGroupValues(formGroupValue): void {
    this.controller.setFormGroupValues(formGroupValue);
  }

  public setContext(context: MspInProductTrialId) {
    this.controller.setContext(context);
  }
}
